// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3bw-q{margin-bottom:.25rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;color:#5656e2}@media(max-width:767px){._3bw-q{-ms-flex-align:start;align-items:flex-start;-ms-flex-direction:column;flex-direction:column}}._2xTk-,._29OzR{display:inline-block;padding:.25rem .75rem;border-radius:.25rem;background-color:#ebebfe;color:#5656e2;margin-right:.5rem;font-size:14px;font-size:.875rem;font-weight:400;line-height:23px;line-height:1.4375rem;font-family:var(--base-font)}@media(max-width:767px){._2xTk-,._29OzR{font-size:1rem;line-height:1.625rem}}._29OzR{color:#fff;background-color:#5656e2}._3UHYX{color:#595757}._3UHYX strong{color:#0373f9;font-weight:inherit}", ""]);
// Exports
exports.locals = {
	"promotion": "_3bw-q",
	"label": "_2xTk-",
	"labelAccent": "_29OzR",
	"bundleOptions": "_3UHYX"
};
module.exports = exports;
